import { UserSite } from '../../api';
import { addDays, getUTCDate } from './date';

export const hasUserAcceptedEssentialTerms = (user: undefined | UserSite): boolean => {
  if (!user?.HasAcceptedPrivacyPolicy || !user?.HasAcceptedTermsOfUse) {
    return false;
  }

  return true;
};

export const shouldUserAcceptCookies = (user: undefined | UserSite): boolean => {
  if (!user?.HasAcceptedCookies) {
    return true;
  }

  if (!user.CookiesAcceptanceDate) {
    return false;
  }

  // Check if cookie acceptance is older than 1 year
  const acceptanceDate = new Date(user.CookiesAcceptanceDate);
  const oneYearFromAcceptance = addDays(acceptanceDate, 365);
  const today = new Date();

  return today > oneYearFromAcceptance;
};

export const userRequiresCaptcha = (user?: UserSite): boolean => {
  if (!user || !user.RequiresCaptcha) {
    return false;
  }

  return !user.RequiresCaptchaExpiresDate || getUTCDate(user.RequiresCaptchaExpiresDate) <= new Date();
};
